export default __webpack_public_path__ + "static/media/cabinet1-after-1920w.96d5c891.png";